import { clientProductEvent, type ClientProductEvent } from "../../../workers/api/src/product-events";
import { canonicalPath } from "./shell/Link";
import { resolveApiUrl } from "./api-client";

type EventInput = ClientProductEvent extends infer Event
  ? Event extends ClientProductEvent
    ? Omit<Event, "channel" | "ts">
    : never
  : never;

export function productChannel(): "web" | "apps_in_toss" {
  return import.meta.env.VITE_CHANNEL === "apps_in_toss" ? "apps_in_toss" : "web";
}

export function trackProductEvent(event: EventInput): boolean {
  const payload=clientProductEvent.safeParse({...event,channel:productChannel(),ts:new Date().toISOString()});
  if(!payload.success)return false;
  const body=JSON.stringify(payload.data);
  if(navigator.sendBeacon?.(resolveApiUrl("/api/events"),new Blob([body],{type:"application/json"})))return true;
  void fetch(resolveApiUrl("/api/events"),{method:"POST",headers:{"content-type":"application/json"},body,keepalive:true}).catch(()=>undefined);return false;
}

export function countBucket(count: number): "0" | "1" | "2-5" | "6+" {
  if (count <= 0) return "0";
  if (count === 1) return "1";
  if (count <= 5) return "2-5";
  return "6+";
}

export function candidateCountBucket(count: number): "0" | "1-3" | "4-10" | "11+" {
  if (count <= 0) return "0";
  if (count <= 3) return "1-3";
  if (count <= 10) return "4-10";
  return "11+";
}

export function positionBucket(position: number): "1-3" | "4-10" | "11+" {
  if (position <= 3) return "1-3";
  if (position <= 10) return "4-10";
  return "11+";
}

export function normalizedRoute(path=location.pathname): Extract<ClientProductEvent,{event:"visit"}>["route"] {
 path=canonicalPath(path);
 if(/^\/protected\//u.test(path))return "/protected/:id";
 if(path==="/protected")return "/protected";
 if(/^\/match\//u.test(path))return "/match/:id";
 if(/^\/case\//u.test(path))return "/case/:id";
 if(/^\/r\/[^/]+\/[^/]+\/poster/u.test(path))return "/r/:sido/:sigungu/poster";
 if(/^\/r\//u.test(path))return "/r/:sido/:sigungu";
 if(/^\/guide\//u.test(path))return "/guide/:slug";
 const routes=["/","/map","/check","/me","/help/family","/returned","/settings/alerts","/guide","/status","/privacy","/terms","/support"] as const;
 return routes.find(r=>r===path)??"/other";
}
export function daysSinceLastBucket(at:string|null,now=Date.now()):"first"|"0"|"1-6"|"7-13"|"14+"{
 if(!at||!Number.isFinite(Date.parse(at)))return "first";
 const days=Math.max(0,Math.floor((now-Date.parse(at))/86400000));return days===0?"0":days<7?"1-6":days<14?"7-13":"14+";
}
export function firstValue(via:Extract<ClientProductEvent,{event:"first_value"}>["props"]["via"]){
 try{if(sessionStorage.getItem("arabom:first-value-session"))return;sessionStorage.setItem("arabom:first-value-session","1");sessionStorage.setItem("arabom:ad-first-value:missing","1")}catch{}
 trackProductEvent({event:"first_value",route:normalizedRoute(),props:{via}});dispatchEvent(new Event("arabom:first-value"));
}
export function visitOnce(){
 try{if(sessionStorage.getItem("arabom:visit-session"))return;sessionStorage.setItem("arabom:visit-session","1");}catch{}
 let at:string|null=null;try{at=JSON.parse(localStorage.getItem("arabom:last-visit")??"null")?.at??null}catch{}
 trackProductEvent({event:"visit",route:normalizedRoute(),props:{daysSinceLastBucket:daysSinceLastBucket(at),installed:matchMedia("(display-mode: standalone)").matches}});
}
